export default __webpack_public_path__ + "static/media/reply-icon.23785374.svg";